import script from "./UserRights.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRights.vue?vue&type=script&setup=true&lang=js"

import "./UserRights.vue?vue&type=style&index=0&id=38c9a13c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c9a13c"]])

export default __exports__